import React from 'react';
import NoAccessIllustration from '@/assets/svg/no-access-illustration.svg';

interface AccessDeniedScreenProps {
  heading: string;
  title: string;
  subtitle: string;
  backButtonLabel: string;
  onBack: () => void;
}

const AccessDeniedScreen: React.FC<AccessDeniedScreenProps> = ({
  heading,
  title,
  subtitle,
  backButtonLabel,
  onBack,
}) => {
  return (
    <div className="bg-white w-full h-full px-4 pt-4 flex flex-col rounded-[4px] shadow-[0px_2px_4px_0px_#00000014]">
      {/* Header */}
      <div className="mb-7 py-[10px]">
        <h1 className="text-[22px] font-normal leading-7 text-[#181A1B]">
          {heading}
        </h1>
      </div>

      {/* Centered content */}
      <div className="flex flex-1 flex-col items-center justify-center gap-5">
        <NoAccessIllustration style={{ width: '171px', height: '182px' }} />

        <div className="flex flex-col items-center gap-1 text-center text-[#474A4C]">
          <p className="text-sm font-medium leading-5 tracking-[0.25px]">
            {title}
          </p>
          <p className="text-sm font-normal leading-5 tracking-[0.25px]">
            {subtitle}
          </p>
        </div>

        <button
          onClick={onBack}
          className="h-10 bg-[#2A4455] px-4 py-2.5 cursor-pointer rounded-lg hover:bg-[#1f3340] transition-colors flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2A4455]"
        >
          <span className="text-white text-sm font-medium leading-5 tracking-[0.1px]">
            {backButtonLabel}
          </span>
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedScreen;
